import { CompaniesFields } from "./CompaniesFields";
import { ContactFields } from "./ContactFields";
import { ContactMethodsFields } from "./ContactMethodsFields";
import { DriversFields } from "./DriversFields";
import { ShippingCompaniesFields } from "./ShippingCompaniesFields";
import { TruckFields } from "./TruckFields";
import { TrucksFields } from "./TrucksFields";
import { UfFields } from "./UfFields";

export const Fields = {
  Truck: TruckFields,
  Contacts: ContactFields,
  ContactMethods: ContactMethodsFields,
  Uf: UfFields,
  Companies: CompaniesFields,
  ShippingCompanies: ShippingCompaniesFields,
  Drivers: DriversFields,
  Trucks: TrucksFields
};
